import {
  ALERT_TYPE_CHANNELS,
  MOBILE_APP_CHANNELS
} from "./alertManagementChannels";
import getSubscriptionEnabledForChannels from "./getSubscriptionEnabledForChannels";
import { SID_NOTIFICATION_TYPES } from "./sidNotificationTypes";

const DEFAULT_SUBSCRIPTION_ENABLED = true;

function getDefaultEnabledForType(type, settingsCategories) {
  const category = settingsCategories?.find(({ key }) => key === type);

  return (
    category?.notificationsEnabledByDefault ?? DEFAULT_SUBSCRIPTION_ENABLED
  );
}

function isMobileSubscriptionEnabled(subscriptions, type, settingsCategories) {
  return getSubscriptionEnabledForChannels({
    subscriptions,
    type,
    channels: MOBILE_APP_CHANNELS,
    defaultEnabled: getDefaultEnabledForType(type, settingsCategories)
  });
}

export function isSidNotificationTypeSubscriptionEnabled(
  subscriptions,
  type,
  settingsCategories
) {
  return getSubscriptionEnabledForChannels({
    subscriptions,
    type,
    channels: ALERT_TYPE_CHANNELS.default,
    defaultEnabled: getDefaultEnabledForType(type, settingsCategories)
  });
}

export function isSidNotificationTypeVisibleOnSidDashboard(
  subscriptions,
  type,
  settingsCategories
) {
  return (
    isSidNotificationTypeSubscriptionEnabled(
      subscriptions,
      type,
      settingsCategories
    ) && isMobileSubscriptionEnabled(subscriptions, type, settingsCategories)
  );
}

export function areSidNotificationSubscriptionsEnabled(
  subscriptions,
  settingsCategories,
  notificationTypes = SID_NOTIFICATION_TYPES
) {
  return notificationTypes.some(type =>
    isSidNotificationTypeVisibleOnSidDashboard(
      subscriptions,
      type,
      settingsCategories
    )
  );
}

export function getEnabledSidNotificationTypes(
  subscriptions,
  settingsCategories,
  notificationTypes = SID_NOTIFICATION_TYPES
) {
  return notificationTypes.filter(type =>
    isSidNotificationTypeVisibleOnSidDashboard(
      subscriptions,
      type,
      settingsCategories
    )
  );
}
